export { BvlAlertErrorComponent as BvlAlertError } from './alert-error.component';
export { BvlAlertErrorModule } from './alert-error.module';
